@let isMultiple = !!data.attributes?.multiple;
@let minCount = data.attributes?.minCount;
@let maxCount = data.attributes?.maxCount;

<!-- we need a dummy form control so the validation works correctly and the form control does not support file uploads -->
<input
  hidden
  [formControl]="control"
  [data]="data"
  [control]="control"
  uiFormInputAttributes
  uiFormInputValidators
>

<div class="upload-container">
  <ui-file-drop-zone
    [multiple]="isMultiple"
    [hasError]="!!control.errors"
    (filesDropped)="onFilesSelected($event)"
  >
    <ui-icon class="upload-icon" faName="upload" faStyle="light"></ui-icon>
    <p class="upload-title">{{ isMultiple ? 'Dateien' : 'Datei' }} für den Upload bereitstellen</p>

    <ui-file-picker-actions
      [data]="data"
      [disabled]="isDisabled() || maxCountReached()"
      [currentFileCount]="control.value?.length ?? 0"
      (filesSelected)="onFilesSelected($event)"
    ></ui-file-picker-actions>

    <p class="upload-hint">
      Maximale Dateigröße für Uploads: {{ allowedMaxSizeMB() | number:'1.0-2' }} MB<br>
      Erlaubte Dateiformate: {{ allowedExtensionsList() }}
      @if (minCount) {
        <br>Mindestanzahl Dateien: {{ minCount }}
      }
      @if (maxCount) {
        <br>Maximale Anzahl Dateien: {{ maxCount }}
      }
    </p>
  </ui-file-drop-zone>
  <mat-error [control]="control" [data]="data" uiFormError class="block mat-caption"></mat-error>
</div>

<ui-file-preview-list
  [values]="selectedFiles()"
  [errors]="control.errors?.['file']"
  [singleColumn]="true"
  (remove)="removeFile($event)"
></ui-file-preview-list>
